"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("bootstrap");
require("./sass/main.scss");
require("./assets/images/favicon-32x32.png");
require("./js/custom.js");
